/**
 * 全局与状态码枚举
 * 生成自用户提供的常量集合，便于在前端统一引用。
 */
export enum GlobalCode {
  // global codes
  Success = 0,
  InvalidParams = 10,
  InternalError = 99,
  Unauthorized = 401,
  TooManyRequest = 429,
  RequestExpired = 601,
  /** 系统维护中 */
  ServerMaintenance = 605,
}
export enum StatusCode {
  // state-code
  AccountRepeat = 100,
  UserNotFound = 101,
  CodeExpired = 102,
  WrongCode = 103,
  WrongPassword = 104,
  LoginFrozen = 105,
  ManualFrozen = 106,
  UserBanned = 107,
  WrongBindUser = 108,
  WrongPwdFormat = 110,
  PhoneNotFound = 111,
  /** 该用户已绑定手机号 */
  PhoneBound = 112,
  /** 该号码已被其他用户绑定 */
  PhoneBoundConflict = 113,
  /** 账号与手机号不匹配 */
  PhoneMismatch = 116,
  /** 广告不存在 */
  AdsNotFound = 180,
  /** 订单不存在 */
  OrderNotFound = 184,
  /** 订单处理中 */
  OrderProcessing = 185,
  /** 用户需要去绑定证件 */
  NeedBindDocument = 122,
  /** 用户需要绑定支付方式 */
  NeedBindPaymentMethod = 123,
  /** 用户需要绑定手机 */
  NeedBindPhone = 124,
  /** 姓名不合法 */
  WrongNameFormat = 125,
  /** 银行信息不合法 */
  WrongBankFormat = 126,
  /** 支行信息不合法 */
  WrongBranchFormat = 127,
  /** 已有绑定邮箱 */
  EmailAlreadyBound = 130,
  /** 账号不合法 */
  WrongAccFormat = 109,

  /** 上传次数过多(1天10次) */
  TooManyRequest = 429,
  /** 身份验证失败 */
  IdentityVerificationFailed = 1020,
  /** 身份证已被他人使用*/
  IdentityAlreadyInUse = 1021,
}
